import Vue from 'vue'
import App from './App.vue'
import router from './router'
import 'amfe-flexible'
import storeLocal from 'storejs'
import apiObj from '@a/js/api.js'

// 样式重置
import '@/assets/styles/reset.css'
// 引入remixicon样式
// import 'remixicon/fonts/remixicon.css'
import '@/assets/fonts/remixicon.css'
// 表单样式
import '@/assets/styles/formSty.less'
import '@/assets/styles/public.css'
import '@/assets/styles/pcsty.less'

Vue.config.devtools = apiObj.VUE_APP_NAME !== 'production'

import {
  Button,
  Toast,
  PullRefresh,
  List,
  Cell,
  CellGroup,
  Popup,
  Picker,
  Stepper,
  Divider,
  Empty,
  Icon,
  Field,
  Notify,
  Overlay,
  CountDown,
  Form,
  RadioGroup,
  Radio,
  Checkbox,
  CheckboxGroup,
  DatetimePicker,
  Area,
  Uploader,
  NumberKeyboard,
  Loading,
} from 'vant'

Vue.use(Button)
Vue.use(Toast)
Vue.use(PullRefresh)
Vue.use(List)
Vue.use(Cell)
Vue.use(CellGroup)
Vue.use(Popup)
Vue.use(Picker)
Vue.use(Stepper)
Vue.use(Divider)
Vue.use(Empty)
Vue.use(Icon)
Vue.use(Field)
Vue.use(Notify)
Vue.use(Overlay)
Vue.use(CountDown)
Vue.use(Form)
Vue.use(RadioGroup)
Vue.use(Radio)
Vue.use(Checkbox)
Vue.use(CheckboxGroup)
Vue.use(DatetimePicker)
Vue.use(Area)
Vue.use(Uploader)
Vue.use(NumberKeyboard)
Vue.use(Loading)

// import VConsole from 'vconsole'
// const _VConsole = new VConsole()
// Vue.use(_VConsole)
// console.log('vconsole is ready')

// 多语言组件
import VueI18n from "vue-i18n";
Vue.use(VueI18n);

const i18n = new VueI18n({
  locale: "zh", // 语言标识
  messages: {
    "zh": require("@a/js/lang/zh-CN"),
    "en": require("@a/js/lang/en-US")
  }
});

Vue.prototype.$storeLocal = storeLocal
Vue.prototype.$AppName = 'ticket'
Vue.config.productionTip = false

new Vue({
  router,
  i18n,
  data: () => {
    return {
      isVersion: 0,
      isJump: 0,
      jumpUrl: '',
      language: 'zh'
    }
  },
  render: (h) => h(App),
}).$mount('#app')
